import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5avawe9fjs: FaireBrandEntity = {
  token: "b_5avawe9fjs",
  type: "brand",
  name: "Spirit Glow Home & Body Essentials",
  avatarUrl:
    "https://cdn.faire.com/fastly/c8c83e0bf9f2ae9fd9c21d44dd915d47d02578eabf9413c016c19224fe1d7b0c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/554ad887f229ba8d47d0bf4e747eff89ed73d163f028190679999ac3e879fb9e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c8c83e0bf9f2ae9fd9c21d44dd915d47d02578eabf9413c016c19224fe1d7b0c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/554ad887f229ba8d47d0bf4e747eff89ed73d163f028190679999ac3e879fb9e.png",
  location: "Fort Myers , FL, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 123,
  isTopShop: true,
  isInsider: true,
  description:
    "Spirit Glow Home & Body Essentials is a faith-centered brand designed with a minimalist, chic style to complement any style home. We create elevated products with a more natural approach with the intention of reflecting the Spirit of God, His light, peace, love and presence in our everyday living. Our prayer is that each product brings warmth, renewal, and a special sacred glow into every space.\n\nBy purchasing from Spirit Glow Home & Body Essentials, you agree to the following:\n\nAll products are sold under the Spirit Glow Home & Body Essentials brand unless White Label Services are purchased. Retailers may not remove or replace our labels, rebrand, or claim our products as their own without authorization. White Label Services allow approved retailers to sell our handcrafted products under their own brand. Unauthorized rebranding is strictly prohibited and may result in refusal of future sales.\n\nOur products may not be resold on third-party marketplaces, including but not limited to Amazon, Etsy, eBay, Walmart Marketplace, or other similar third-party selling platforms. Approved retailers may sell Spirit Glow products through their own independently operated website, physical retail location, and approved social media sales channels.",
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:42.161Z",
    importedBy: "entity-db-cli",
  },
};
